
import { Injectable } from '@angular/core';
import { Action } from '@ngrx/store';

export const ADD_REQ_QUOTE_CALCULATION = '[REQ_QUOTE_CALCULATION] Add';
export const REMOVE_REQ_QUOTE_CALCULATION = '[REQ_QUOTE_CALCULATION] Remove';

// AddPersonalDetails
export class AddReqQuoteCalculation implements Action {
    readonly type = ADD_REQ_QUOTE_CALCULATION;

    constructor(public payload) { }
}
// RemovePersonalDetails
export class RemoveReqQuoteCalculation implements Action {
    readonly type = REMOVE_REQ_QUOTE_CALCULATION;

    constructor(public payload: number) { }
}

export type Actions = AddReqQuoteCalculation | RemoveReqQuoteCalculation;
